import type { Injector } from '@angular/core';
import { afterNextRender, effect } from '@angular/core';

/**
 * Runs `sync` after the render that follows each change of the form's value — and for the value the widget
 * opened with only when `measureInitial` says so (a widget just created, see `NewZeroWidgetsService`).
 *
 * A zero-block widget mirrors its rendered size back into its position. Doing that for the value it opened
 * with writes to the store on page load, which arms the autosave: opening a page re-saves it, and on a legacy
 * page that save is what converts it to v0. The FormGroup views this replaced reacted to `valueChanges` only,
 * so they never measured on load either. A re-run with an unchanged size is harmless: the widgets compare
 * before writing.
 */
export function afterFormValueChange(
    injector: Injector,
    value: () => unknown,
    sync: () => void,
    { measureInitial = false }: { measureInitial?: boolean } = {}
): void {
    let isInitialValue = !measureInitial;

    effect(
        () => {
            value();

            if (isInitialValue) {
                isInitialValue = false;
                return;
            }

            afterNextRender(() => sync(), { injector });
        },
        { injector }
    );
}
